import { render, staticRenderFns } from "./patchRoleDialog.vue?vue&type=template&id=3fa8a296&scoped=true"
import script from "./patchRoleDialog.vue?vue&type=script&lang=js"
export * from "./patchRoleDialog.vue?vue&type=script&lang=js"
import style0 from "./patchRoleDialog.vue?vue&type=style&index=0&id=3fa8a296&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa8a296",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fa8a296')) {
      api.createRecord('3fa8a296', component.options)
    } else {
      api.reload('3fa8a296', component.options)
    }
    module.hot.accept("./patchRoleDialog.vue?vue&type=template&id=3fa8a296&scoped=true", function () {
      api.rerender('3fa8a296', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/siteSetting/patchRoleDialog.vue"
export default component.exports